<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <form>
            <div class="zas-row">
                <div class="zas-main-col">
                    <div class="gutter-container">
                        <zbd-input
                            #creatorName
                            type="text"
                            name="creatorName"
                            label="Vermittler"
                            [validity]="validity"
                            class="gutter-main"
                            [entity]="state.protocol"
                            property="CreatorName"
                            [updateFn]="persistence.updateProtocol"
                        ></zbd-input>
                        <div
                            class="gutter-side gutter-side-padded zas-info-directive"
                        >
                            <div class="dropdown-toggle">
                                <span
                                    class="zbd-action-icon icon-i-snippet tracking-action"
                                    (click)="
                                        fillAgentName(
                                            state.agent,
                                            state.protocol
                                        )
                                    "
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zas-main-col"></div>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="customerName"
                    label="Kunde"
                    [validity]="validity"
                    class="zas-main-col"
                    [value]="getCustomerName(state.customer)"
                ></zbd-input>
                <zbd-input
                    type="select"
                    name="salesType"
                    label="Vertriebsart"
                    class="zas-main-col"
                    [validity]="validity"
                    [entity]="state.consultationProcess"
                    property="SalesType"
                    [updateFn]="persistence.updateConsultationProcess"
                >
                    <option value="" disabled></option>
                    <option *ngFor="let value of salesTypes" [value]="value">
                        {{ ZASConstants.SalesTypeTable[value] }}
                    </option>
                </zbd-input>
            </div>
            <div class="zas-row">
                <zbd-list
                    label="Weitere Teilnehmer"
                    itemName="Teilnehmer"
                    [collection]="state.protocol.Participants"
                    [template]="participant"
                    class="zas-main-col"
                    [addFn]="addParticipant(state.protocol)"
                    [deleteFn]="persistence.deleteParticipant"
                    [validity]="validity"
                ></zbd-list>
                <zbd-list
                    label="Beratung vom"
                    name="consultationDates"
                    itemName="Datum"
                    [collection]="state.consultationProcess.ConsultationDates"
                    [template]="date"
                    class="zas-main-col"
                    [addFn]="addConsultationDate(state.consultationProcess)"
                    [deleteFn]="persistence.deleteConsultationDate"
                    [validity]="validity"
                ></zbd-list>
            </div>
        </form>
    </ng-container>
</ng-container>

<ng-template #participant let-item let-validity="validity">
    <zbd-input
        style="display: inline-block; width: 80%"
        type="text"
        [name]="item.Id"
        [entity]="item"
        property="Name"
        [updateFn]="persistence.updateParticipant"
        [validity]="validity.participantItems"
    ></zbd-input>
</ng-template>

<ng-template #date let-item let-validity="validity">
    <zbd-input
        style="display: inline-block; width: 80%"
        type="date"
        [name]="item.Id"
        [entity]="item"
        property="Date"
        [updateFn]="persistence.updateConsultationDate"
        [validity]="validity.consultationDateItems"
    ></zbd-input>
</ng-template>
